<template>
  <div class="logo-wrap" :class="{ whitebg: state == 1 }">
    <el-row>
      <el-col :span="12">
        <div>
          <router-link :to="{ name: 'index' }">
            <img :src="top_logo" alt="sbz_logo" />
          </router-link>
        </div>
      </el-col>
      <el-col :span="12" v-if="state == 1">
        <div class="search-wrap" @click.stop>
          <el-input
            class="formItemInput"
            clearable
            v-model="keyword"
            :placeholder="shade"
            @clear="handlerInput1(keyword)"
            @focus="
              handleInput(keyword);
              getlist(keyword);
            "
            @input="
              handleInput(keyword);
              getlist(keyword);
            "
            @keyup.enter.native="goSearch()"
          ></el-input>
          <el-button type="primary" class="my-search" @click="goSearch()"
            >搜索</el-button
          >
          <div class="search-list-wrap">
            <ul class="search-list" v-show="showSuggest">
              <li
                v-for="item in restaurants"
                :key="item.suggestion"
                @click.stop="
                  request_id = pullDownrequest_id;
                  goSearch(item.suggestion);
                "
              >
                {{ item.suggestion }}
              </li>
              <li
                class="clear-his"
                v-if="restaurants.length > 0"
                @click="resetSearch"
              >
                关闭
              </li>
            </ul>
            <ul class="search-list" v-show="showHistory">
              <li
                v-for="item in searchHistory"
                :key="item"
                @click.stop="
                  request_id = '';
                  goSearch(item);
                "
              >
                {{ item }}
              </li>
              <li
                class="clear-his"
                v-if="searchHistory.length > 0"
                @click="clearHistroy"
              >
                清空历史记录
              </li>
            </ul>
          </div>
          <router-link :to="{ name: 'shopping-cart' }">
            <el-button class="tab-cart" icon="el-icon el-icon-cart">
              购物车
              <span>
                ({{ $store.state.total > 99 ? "99+" : $store.state.total }})
              </span>
            </el-button>
          </router-link>
        </div>
        <div class="search-history">
          <span
            v-for="(item, index) in hotsearch.result"
            :key="index"
            :label="item.hot"
            :value="index"
            @click="
              request_id = hotsearch.request_id;
              keyword = item.hot;
              goSearch();
            "
            >{{ item.hot }}</span
          >
        </div>
      </el-col>
      <el-col :span="12" v-if="state == 2" class="clearfix">
        <div class="cart_steps Fl-l">
          <img src="../assets/images/cart_steps.png" />
        </div>
      </el-col>
      <el-col :span="12" v-if="state == 3" class="clearfix">
        <div class="cart_steps Fl-l">
          <img src="../assets/images/cart_steps2.png" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import top_logo from "../assets/images/logo_top.png";
export default {
  data() {
    return {
      clearinput: false,
      search: [],
      restaurants: [],
      hotsearch: {},
      shade: "",
      keyword: "",
      searchHistory: [],
      cartNumber: 0,
      top_logo: top_logo,
      name: "",
      timeout: null
    };
  },
  props: {
    state: String,
    searchName: String
  },
  computed: {
    searchData() {
      if (this.keyword) {
        let arr = [];
        this.restaurants.map(item => {
          arr.push(item.suggestion);
        });
        return arr;
      } else {
        return this.searchHistory;
      }
    },
    showSuggest() {
      return this.$store.state.search.showSuggest;
    },
    showHistory() {
      return this.$store.state.search.showHistory;
    }
  },
  updated() {
    this.name = window.sessionStorage.getItem("name");
  },
  mounted() {
    if (
      this.$util.getSessionStorage("Authorization").Authorization &&
      sessionStorage.getItem("company")
    ) {
      this.getCartNum();
    }
    if (this.$util.getSessionStorage("Authorization").Authorization) {
      this.getresou();
      this.shading();
    }
    if (this.$util.getSessionStorage("searchHistory").searchHistory) {
      var arr = new Set(
        JSON.parse(this.$util.getSessionStorage("searchHistory").searchHistory)
      );
      this.searchHistory.push(...arr);
    }
    if (this.$route.query.logo) {
      sessionStorage.setItem("logoImg", this.$route.query.logo);
      this.top_logo =
        "https://ossimg.shangbanzugroup.com/gjy/logo/" +
        decodeURIComponent(sessionStorage.getItem("logoImg"));
    } else {
      if (sessionStorage.getItem("logoImg")) {
        this.top_logo =
          "https://ossimg.shangbanzugroup.com/gjy/logo/" +
          decodeURIComponent(sessionStorage.getItem("logoImg"));
      }
    }
  },
  created() {
    this.$bus.$off("get-cartNum");
    this.$bus.on("get-cartNum", this.getCartNum);
  },
  watch: {
    searchName: {
      handler(newValue) {
        if (newValue) {
          this.keyword = newValue;
        }
      },
      immediate: true,
      deep: true
    },
    searchHistory: {
      handler(newValue) {
        if (newValue.length == 11) {
          this.searchHistory.pop();
        }
      }
    }
  },
  methods: {
    cleaript() {
      this.keyword = "";
    },
    clearall() {
      this.$emit("clearall");
      this.keyword = "";
      this.$router.push({
        name: "products-list",
        query: { search: "" }
      });
    },
    clearHistroy() {
      this.searchHistory = [];
      this.$util.removeSessionStorage("searchHistory");
      this.resetSearch();
    },
    getresou() {
      this.$reqGet("api/ecomm/getHotSearchs").then(res => {
        this.request_id = res.data.data.request_id;
        this.hotsearch = res.data.data;
      });
    },
    shading() {
      this.$reqGet("api/ecomm/getHint").then(res => {
        if (res.data.data.result.length !== 0) {
          this.shade = res.data.data.result[0].hint;
          this.shadeRequest_id = res.data.data.request_id;
        }
      });
    },

    getlist(query) {
      this.keyword = query;
      if (!this.keyword) {
        return;
      }
      this.$reqGet("api/ecomm/dropDownTips", { search: query }).then(res => {
        this.pullDownrequest_id = res.data.data.request_id;
        this.restaurants = res.data.data.suggestions;
      });
    },

    goSearch(suggestion) {
      if (this.keyword && this.keyword === suggestion) {
        return;
      }
      if (suggestion) {
        this.keyword = suggestion;
      }
      this.resetSearch();
      let inputName = "";
      if (!this.keyword && this.shade) {
        this.keyword = this.shade;
        this.request_id = this.shadeRequest_id;
        inputName = this.shade;
      } else if (this.keyword) {
        inputName = this.keyword;
      }
      if (this.keyword && this.searchHistory.indexOf(this.keyword) == -1) {
        this.searchHistory.unshift(this.keyword);
        this.$util.setSessionStorage({
          searchHistory: JSON.stringify(this.searchHistory.slice(0, 10))
        });
      }
      if (this.$route.name === "products-list") {
        this.$router.push({
          query: {
            search: inputName,
            request_id: this.request_id,
            category_id: this.$route.query.category_id
          }
        });
        return;
      }
      if (this.$route.name === "category-home") {
        this.$router.push({
          name: "products-list",
          query: {
            search: inputName,
            request_id: this.request_id,
            category_id: this.$route.query.id
          }
        });
        return;
      }
      this.$router.push({
        name: "products-list",
        query: {
          search: inputName,
          request_id: this.request_id
        }
      });
    },
    getCartNum() {
      this.$reqGet("api/store/cart/quantity").then(res => {
        this.$store.state.total = res.data.data.total;
      });
    },
    resetSearch() {
      this.$store.commit("changeSuggest", false);
      this.$store.commit("changeHistory", false);
    },
    handlerInput1() {
      this.$store.commit("clearsonsearch", "");
    },
    handleInput(keyword) {
      var SearchHistoryname = document.getElementsByClassName(
        "search-list-wrap"
      );
      if (this.searchHistory.length !== 0 || this.keyword) {
        SearchHistoryname[0].style.border = "1px solid #f5f5f5";
        SearchHistoryname[0].style.background = "rosybrown";
      } else {
        SearchHistoryname[0].style.border = "0px solid #fff";
        SearchHistoryname[0].style.background = "none";
      }
      if (keyword) {
        this.$store.commit("changeSuggest", true);
        this.$store.commit("changeHistory", false);
      } else {
        this.$store.commit("changeSuggest", false);
        this.$store.commit("changeHistory", true);
      }
    }
  }
};
</script>

<style lang="less">
.logo-wrap {
  color: #666;
  .el-row {
    width: 1200px;
    margin: 0 auto;
    padding: 26px 0;
  }
  img {
    width: auto;
    height: 50px;
  }
}
.whitebg {
  background-color: #fff;
}
.search-wrap {
  position: relative;
  display: flex;
  .el-input {
    width: 360px;
    margin-right: 120px;
  }
  .search-list-wrap {
    position: absolute;
    z-index: 100;
    top: 45px;
    border: 1px solid #f5f5f5;
    background: rosybrown;
    overflow-x: hidden;
  }
  .search-list {
    width: 340px;
    max-height: 300px;
    overflow-y: scroll;
    background: #fff;
    li {
      padding: 5px 10px;
      background: #fff;
      cursor: pointer;
    }
    .clear-his {
      text-align: right;
      padding-bottom: 6px;
      border-top: 1px solid #f5f5f5;
    }
  }
  .search-list::-webkit-scrollbar {
    //先改变body的滚动条宽度
    width: 6px;
  }
  .search-list::-webkit-scrollbar-track {
    //再改变body的滚动条轨道颜色
    background: rgba(200, 200, 200);
    border-radius: 5px;
  }

  .search-list::-webkit-scrollbar-thumb {
    //最后改变body的滚动条滑轨相关的样式
    background: rgba(120, 120, 120, 0.3);
    border-radius: 5px;
  }
  .el-icon-mysearch {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 400px;
    padding-top: 12px;
    border: 1px solid #ddd;
    z-index: 100;
    font-size: 17px;
    text-align: center;
    color: #6d6d6d;
    cursor: pointer;
    box-sizing: border-box;
  }
  .my-search {
    position: absolute;
    left: 340px;
    background: #4ac0fd;
    border-color: #4ac0fd;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .tab-cart {
    width: 140px;
    height: 40px;
    border-radius: 0;
    color: #fc0010;
    padding: 0;
    display: flex;
    align-items: center;
    .el-icon-cart {
      margin-left: 20px;
    }
    &:hover {
      background: rgba(252, 0, 16, 0.1);
      border-color: #fff;
    }
    > span {
      flex: 1;
    }
  }
}
.el-select__caret {
  margin-right: 15px;
}
.search-history {
  width: 400px;
  height: 20px;
  overflow: hidden;
  margin-top: 10px;
  text-align: left;
  span {
    margin-right: 10px;
    cursor: pointer;
    white-space: nowrap;
  }
}
.cart_steps {
  margin-top: 15px;
  padding-left: 100px;
  img {
    width: 100%;
    height: auto;
  }
}
.el-input--suffix {
  display: block;
}
.formItemInput .el-input__inner {
  position: relative;
  width: 100%;
  border-radius: 5px 0 0 5px;
  border-right: 0px;
  border-color: #4ac0fd;
}
.error {
  position: absolute;
  top: 13px;
  right: 276px;
  width: 12px;
  height: 13px;
  // background-color: pink;
  cursor: pointer;
}
.el-input__suffix {
  margin-right: 17px;
}
.el-input__suffix-inner {
  width: 30px;
}
.close {
  position: absolute;
  right: 280px;
  top: 10px;
  width: 20px;
  height: 20px;
  z-index: 55;
  cursor: pointer;
}
.close::before,
.close::after {
  position: absolute;
  content: "";
  background-color: #e4e4e4;
  left: 20px;
  width: 1px;
  height: 20px;
}

.close::before {
  transform: rotate(45deg);
}

.close::after {
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/top-logo.vue